import React from "react";
import "./Dots.scss";
const Dots = () =>{
    return <div className={"dot-flashing"}>

    </div>
};

export default  Dots;